<template>
    <CRow>
        <CCol col="12" lg="8">
            <CCard>
                <CCardHeader>
                    <strong
                    >{{ service.title }}: {{ promotion.title }}</strong
                    >
                    <RestaurantTableOrderBadge />
                </CCardHeader>
                <CCardBody>
                    <PromotionsTabLinks :service-name="serviceName" />
                    <CRow class="pl-3 pb-3" />
                    <CForm>
                        <CInput
                            v-model="promotion.title"
                            label="Название"
                            placeholder="Введите название акции"
                        />
                        <CSelect
                            :value.sync="promotion.type"
                            :horizontal="true"
                            :options="promotionTypes"
                            label="Тип"
                            placeholder="Выберите тип"
                        />

                        <CInput v-model="promotion.discount" label="Скидка" />

                        <CInput v-model="promotion.orders_quantity" label="Количество первых заказов в заведении по акции" />
                        
                        <CInput v-model="promotion.entity_discount_percent" label="Размер скидки от ресторана (%)" />
                        
                        <CInput v-model="promotion.entity_discount_sum" label="Размер скидки от ресторана (руб.)" />
                        
                        <CInput v-model="promotion.mircity_commission" label="Размер комиссии МИРСИТИ (%)" />

                        <ScheduleUpdate :schedule="schedule" @set-schedule="setSchedule"/>

                        <CRow class="mb-1 mt-4">
                            <CCol cols="12" md="2"> Дата начала: </CCol>
                            <CCol cols="12" md="4">
                                <DatePicker
                                    v-model="datepicker.dateFrom"
                                    :language="datepicker.lang"
                                    :format="datepicker.format"
                                    input-class="custom-datepicker"
                                    placeholder="Выберите дату..."
                                />
                            </CCol>
                            <CCol cols="12" md="2"> Дата окончания: </CCol>
                            <CCol cols="12" md="4">
                                <DatePicker
                                    v-model="datepicker.dateTo"
                                    :language="datepicker.lang"
                                    :format="datepicker.format"
                                    input-class="custom-datepicker"
                                    placeholder="Выберите дату..."
                                />
                            </CCol>
                        </CRow>
                        <CRow class="mt-4 mb-2 align-items-center">
                            <CCol cols="12" md="2"> Время (от) </CCol>
                            <CCol cols="12" md="4">
                                <CInput
                                    v-model="promotion.time_from"
                                    class="m-0"
                                    type="time" />
                            </CCol>
                            <CCol cols="12" md="2"> Время (до) </CCol>
                            <CCol cols="12" md="4">
                                <CInput
                                    v-model="promotion.time_to"
                                    class="m-0"
                                    type="time" />
                            </CCol>
                        </CRow>
                        <CRow class="pl-3 mb-4">
                            <CButton
                                color="light"
                                class="mr-3"
                                @click="resetDate"
                            >Сброс дат и времени</CButton>
                        </CRow>
                        <CRow>
                            <CCol
                                tag="label"
                                sm="3"
                                class="col-form-label">
                                Неограничено по времени
                            </CCol>
                            <CCol sm="9">
                                <CSwitch
                                    color="dark"
                                    shape="pill"
                                    variant="opposite"
                                    :checked.sync="promotion.unlimited"
                                />
                            </CCol>
                        </CRow>
                        <CRow>
                            <CCol
                                tag="label"
                                sm="3"
                                class="col-form-label">
                                Учитывать при интеграции
                            </CCol>
                            <CCol sm="9">
                                <CSwitch
                                    color="dark"
                                    shape="pill"
                                    variant="opposite"
                                    :checked.sync="promotion.accounting_in_integration"
                                />
                            </CCol>
                        </CRow>
                        <CRow form class="form-group">
                            <CCol
                                tag="label"
                                sm="3"
                                class="col-form-label">Тип доставки</CCol>
                            <CCol sm="9">
                                <CSelect
                                    inline
                                    :value.sync="promotion.delivery_type"
                                    :options="delivery_types"
                                    placeholder="Тип доставки..."
                                />
                            </CCol>
                        </CRow>
                        <CRow>
                            <CCol
                                tag="label"
                                sm="3"
                                class="col-form-label">
                                Активен
                            </CCol>
                            <CCol sm="9">
                                <CSwitch
                                    color="dark"
                                    shape="pill"
                                    variant="opposite"
                                    :checked.sync="promotion.enabled"
                                />
                            </CCol>
                        </CRow>
                    </CForm>
                </CCardBody>
                <CCardFooter>
                    <CButton
                        color="primary"
                        class="mr-3"
                        @click="save"
                    >Сохранить</CButton
                    >
                    <CButton
                        color="light"
                        class="mr-3"
                        @click="goBack"
                    >Отмена</CButton
                    >
                    <CButton
                        color="danger"
                        class="mr-3"
                        @click="deleteModal = true"
                    >Удалить</CButton
                    >
                </CCardFooter>
            </CCard>
        </CCol>

        <CModal
            title="Подтверждение"
            color="danger"
            :show.sync="deleteModal"
            :footer="false"
        >
            <template>
                <div slot="body-wrapper" class="modal-body">
                    <p>
                        Вы действительно хотите удалить акцию? Это действие
                        нельзя будет отменить.
                    </p>
                </div>
                <div slot="footer">
                    <CButton
                        color="light"
                        class="ml-3"
                        @click="deleteModal = false"
                    >Отмена</CButton
                    >
                    <CButton
                        color="danger"
                        class="ml-3"
                        @click="deletePromotion"
                    >Удалить</CButton
                    >
                </div>
            </template>
        </CModal>
    </CRow>
</template>

<script>
    import Vue from 'vue';
    import moment from 'moment';
    import PromotionsTabLinks from '@/components/promotions/PromotionsTabLinks';
    import ScheduleUpdate from '@/components/ScheduleWorkPromotionUpdate';
    import { PROMOTION_TYPE } from '../../utils/promotion';
    import { promotionTypeTitle } from '../../utils/promotion-views';
    const { DELIVERY_TYPE } = require('../../utils/order');
    import { getRouteName, cutPlural } from '../../utils/route-name';
    import DatePicker from 'vuejs-datepicker';
    import { ru } from 'vuejs-datepicker/dist/locale';

    export default {
        name: 'PromotionEdit',

        components: {
            PromotionsTabLinks,
            ScheduleUpdate,
            DatePicker
        },

        data() {
            return {
                serviceName: getRouteName(this.$router.currentRoute.path),
                service: {},
                promotion: {},
                deleteModal: false,
                schedule: undefined,
                delivery_types: null,
                datepicker: {
                    lang: ru,
                    format: 'dd.MM.yyyy',
                    dateFrom: null,
                    dateTo: null,
                },
            };
        },

        computed: {
            promotionTypes() {
                const typeOptions = [];
                for (var prop in PROMOTION_TYPE) {
                    typeOptions.push({
                        value: PROMOTION_TYPE[prop],
                        label: promotionTypeTitle(PROMOTION_TYPE[prop]),
                    });
                }
                return typeOptions;
            },
        },

        mounted() {
            const id = parseInt(this.$route.params.id);
            const promotion_id = parseInt(this.$route.params.promotion_id);
            let url = `/${this.serviceName}/${id}`;

            if (this.serviceName === 'entities') {
                url = `/${this.serviceName}/get/${id}`
            }
            Vue.axios
                .get(url)
                .then(resp => {
                    this.service = resp.data;
                })
                .catch(() => {
                    this.$root.$emit('showError', 'Ошибка загрузки данных.');
                });
            Vue.axios
                .get('/promotions/' + promotion_id)
                .then(resp => {
                    delete resp.data.clients;
                    this.promotion = resp.data;
                    if(this.promotion.date_start) {
                        this.promotion.date_start = moment(this.promotion.date_start).format('YYYY-MM-DD');
                        this.datepicker.dateFrom = moment(this.promotion.date_start).format('YYYY-MM-DD');
                    }
                    if(this.promotion.date_finish) {
                        this.datepicker.dateTo = moment(this.promotion.date_finish).format('YYYY-MM-DD');
                        this.promotion.date_finish = moment(this.promotion.date_finish).format('YYYY-MM-DD');
                    }
                    this.promotion.time_from = this.promotion.time_from
                        ? moment('Mon Jun 28 2021 ' + this.promotion.time_from + ' GMT+0000').local().format('HH:mm:ss')
                        : null;
                    this.promotion.time_to = this.promotion.time_to
                        ? moment('Mon Jun 28 2021 ' + this.promotion.time_to + ' GMT+0000').local().format('HH:mm:ss')
                        : 0;
                    this.promotion.unlimited = Boolean(this.promotion.unlimited);
                    this.promotion.accounting_in_integration = Boolean(this.promotion.accounting_in_integration);
                    this.promotion.enabled = Boolean(this.promotion.enabled);
                    if (resp.data.schedule.length != 0) {
                        this.schedule = resp.data.schedule;
                    }
                })
                .catch(() => {
                    this.$root.$emit('showError', 'Ошибка загрузки данных.');
                });

            if(!this.delivery_types) {
                const types = [];
                types.push({ value: DELIVERY_TYPE.DOOR, label: 'До двери' });
                types.push({ value: DELIVERY_TYPE.MEETING_POINT, label: 'Место встречи' });
                types.push({ value: DELIVERY_TYPE.WITHOUT, label: 'Без доставки' });
                types.push({ value: DELIVERY_TYPE.COLLECT, label: 'Сборка заказа' });
                types.push({ value: null, label: 'Без типа доставки' });
                this.delivery_types = types;
            }
        },

        methods: {
            setSchedule(schedule) {
                this.schedule = schedule;
            },
            save() {
                if (!this.promotion.title) {
                    this.$root.$emit('showError', 'Укажите название акции.');
                    return;
                }
                if (!this.promotion.type) {
                    this.$root.$emit('showError', 'Выберите тип акции.');
                    return;
                }
                this.promotion[`${cutPlural(this.serviceName)}_id`] = this.service.id;
                this.promotion.discount = this.promotion.discount
                    ? parseInt(this.promotion.discount)
                    : 0;
                this.promotion.time_from = this.promotion.time_from
                    ? moment(this.promotion.time_from, 'HH:mm').utc().format('HH:mm:ss')
                    : null;
                this.promotion.time_to = this.promotion.time_to
                    ? moment(this.promotion.time_to, 'HH:mm').utc().format('HH:mm:ss')
                    : null;
                this.promotion.delivery_type === this.promotion.delivery_type;
                this.promotion.enabled = this.promotion.enabled ? true : false;
                this.promotion.unlimited = this.promotion.unlimited ? true : false;
                this.promotion.accounting_in_integration = this.promotion.accounting_in_integration ? true : false;
                this.promotion.orders_quantity = +this.promotion.orders_quantity || null;
                this.promotion.entity_discount_percent = this.promotion.entity_discount_percent ? +this.promotion.entity_discount_percent : null;
                this.promotion.entity_discount_sum = this.promotion.entity_discount_sum ? +this.promotion.entity_discount_sum : null;
                this.promotion.mircity_commission = this.promotion.mircity_commission ? +this.promotion.mircity_commission : null;
                this.promotion.date_start = this.datepicker.dateFrom ? moment(Date.parse(this.datepicker.dateFrom)).format('YYYY-MM-DD') : null;
                this.promotion.date_finish = this.datepicker.dateTo ? moment(Date.parse(this.datepicker.dateTo)).format('YYYY-MM-DD') : null;
                this.promotion.schedule = this.schedule;
                Vue.axios
                    .put('/promotions/' + this.promotion.id, this.promotion)
                    .then(() => {
                        this.goBack();
                    })
                    .catch(err => {
                        this.$root.$emit('showError', 'Ошибка сохранения.');
                    });
            },

            deletePromotion() {
                Vue.axios
                    .delete('/promotions/' + this.promotion.id)
                    .then(() => {
                        let path = `/${this.serviceName}/${this.service.id}/promotions`;

                        if (this.serviceName === 'entities') {
                            path = `/entities/${this.$route.params.code}/${this.$route.params.id}/promotions`
                        }
                        this.$router.push({ path });
                    })
                    .catch(err => {
                        this.$root.$emit('showError', 'Ошибка удаления.');
                    });
            },

            resetDate() {
                this.datepicker.dateFrom = null;
                this.datepicker.dateTo = null;
                this.promotion.time_from = null;
                this.promotion.time_to = null;
            },

            goBack() {
                let path = `/${this.serviceName}/${this.service.id}/promotions`;

                if (this.serviceName === 'entities') {
                    path = `/entities/${this.$route.params.code}/${this.$route.params.id}/promotions`
                }
                this.$router.push({ path });
            },
        },
    };
</script>

<style>
input.custom-datepicker {
  border: 1px solid;
  border-color: #d8dbe0;
  width: 100%;
}
</style>
